import { Button, Form, Input, Modal, Spin, Typography } from 'antd'
import React, { useState } from 'react'
import rolesAdmin from '../../../../apis/admin/rolesService'
import notificationHandler from '../../../atoms/Notification'
import { Link, useNavigate } from 'react-router-dom'
import { ArrowLeftOutlined, ExclamationCircleOutlined, LoadingOutlined, ReloadOutlined, SaveOutlined } from '@ant-design/icons'

type Props = {}

const CreateRoles = (props: Props) => {
  const [form] = Form.useForm();
  const { Title } = Typography;
    const navigate = useNavigate()
    const [roleName, setRoleName] = useState('')
    const [loading, setLoading] = useState(false);
    const [modal, contextHolder] = Modal.useModal();

  const confirm = (values: any) => {
      modal.confirm({
        title: 'Bạn có chắc chắn muốn thêm quyền?',
        icon: <ExclamationCircleOutlined />,
        okText: 'Đồng ý',
        cancelText: 'Hủy',
        okType:'danger',
        onOk: () => onFinish(values)
      });
    };

    const antIcon = <LoadingOutlined style={{ fontSize: 70, position: 'fixed' }} spin />;

    const onFinish = (values: any) => {
        setLoading(true);
        const data = {
            roleName: values.roleName,
        }
        rolesAdmin.addRoles(data).then(() => {
            notificationHandler('success', 'Thêm mới quyền thành công!')
            navigate('/admin/listRoles')
            setLoading(false);
        }).catch((err) => {
            notificationHandler('error', err.response.data.data.msg_content)
            setLoading(false);
        })
    };
    const handleChange = (values: any) => {
        setRoleName(values);
    }
    const validateSpecialCharacters = (_: any, value: any) => {
        const specialCharsRegex = /[!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/;
        if (specialCharsRegex.test(value)) {
            return Promise.reject('Dữ liệu nhập vào không được chứa ký tự đặc biệt!');
        }
        return Promise.resolve();
    };
    const trimValue = (value: any) => {
        if (typeof value === 'string') {
            return value.trim();
        }
        return value;
    };
    return (
        <div className='p-[20px]'>
            <Spin indicator={antIcon} spinning={loading} />
            <Title className='!text-[20px]'>Thêm mới Quyền</Title>
            <Form
              form={form}
                name="basic"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                style={{ maxWidth: 600 }}
                initialValues={{ remember: true }}
                layout={'vertical'}
                onFinish={confirm}
                autoComplete="off"
            >
              <Form.Item label="Tên quyền"
                // @ts-ignore
                         onBlur={(e)=>{
                           form.setFieldValue('roleName',e.target.value.trim())
                         }}
                // normalize={(value) => value.trim()}
                         name="roleName"
                         rules={[{ required: true, message: 'Vui lòng nhập tên quyền!' },{
                           validator: validateSpecialCharacters,
                         }]}>
                <Input showCount maxLength={30}/>
              </Form.Item>
                <Form.Item>
                    <div className='flex'>
                        <Button htmlType="button" type='primary' className='mt-4 mr-4 border-[#808080] hover:border-[#808080] hover:text-[#808080] hover:bg-white bg-[#808080] text-white'><Link to={'/admin/listRoles'} className='flex items-center'><ArrowLeftOutlined className='mr-2' /> Quay lại</Link></Button>
                        <Button htmlType="submit" type='primary' className='mt-4 text-white bg-[#1890ff] hover:bg-white hover:text-[#1890ff]' loading={loading}><SaveOutlined /> Lưu</Button>
                        <Button htmlType="reset" className='mt-4 text-[##ff4d4f] ml-4  bg-[#ff4d4f] text-white' danger><ReloadOutlined /> Đặt lại</Button>
                    </div>
                </Form.Item>
                {contextHolder}
            </Form>
        </div>
    )
}

export default CreateRoles
